import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Form, notification, Button, InputNumber, Switch } from 'antd';
import MainContainer from '../../components/MainContainer';

@inject(
  'loginStore',
  'CmsLanguageStore'
)
@observer
class CmsLanguage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingLogoLanguage: false,
      uploadingLoginLanguage: false
    }
  }

  componentDidMount() {
    this.props.loginStore.authenticateAdmin().then(response => {
      if (!response) {
        this.props.history.push('/admin/login');
      }
    });

    this.props.CmsLanguageStore.getData();
  }

  update = () => {
    this.props.CmsLanguageStore.update().then(resp => {
      if (!resp.isError) {
        this.props.CmsLanguageStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Language is successfully updated.',
          duration: 1
        });
      }
    });
  }

  activate = (id) => {
    this.props.CmsLanguageStore.activate(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsLanguageStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Language is successfully activated.',
          duration: 1
        });
      }
    });
  }

  deactivate = (id) => {
    this.props.CmsLanguageStore.deactivate(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsLanguageStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Language is successfully deactivated.',
          duration: 1
        });
      }
    });
  }

  render() {
    const {
      data,
      selectedData
    } = this.props.CmsLanguageStore;

    return (
      <MainContainer title='Customize Language' menukey='cms-language'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Form.Item>
              <div className='stm-display-flex 
                              stm-stm-width-100-percent 
                              stm-background-white-three 
                              stm-font-size-14 
                              stm-line-height-18
                              stm-font-weight-bold 
                              stm-color-495057 
                              stm-border-bottom-width-2 
                              stm-border-bottom-color-white-two 
                              stm-border-bottom-style-solid'>
                <div className='stm-width-20-percent stm-padding-8'>Name</div>
                <div className='stm-width-20-percent stm-padding-8'>Original Name</div>
                <div className='stm-width-20-percent stm-padding-8'>Available</div>
                <div className='stm-width-20-percent stm-padding-8'>Sort</div>
                <div className='stm-width-20-percent stm-padding-8'>Action</div>
              </div>
              <>
                {
                  data.map(item => {
                    return (
                      <>
                        <div
                          key={item.id}
                          className='stm-display-flex 
                                    stm-stm-width-100-percent 
                                    stm-font-size-14 
                                    stm-line-height-18
                                    stm-border-top-width-1 
                                    stm-border-top-color-white-two 
                                    stm-border-top-style-solid'
                          style={{ background: item.isAvailable ? '#FFFFFF' : '#6C757D', color: item.isAvailable ? '#495057' : '#FFFFFF' }}>
                          <div className='stm-width-20-percent stm-padding-8'>{item.name}</div>
                          <div className='stm-width-20-percent stm-padding-8'>{item.originalName}</div>
                          <div className='stm-width-20-percent stm-padding-8'>{item.isAvailable ? 'Yes' : 'No'}</div>
                          <div className='stm-width-20-percent stm-padding-8'>{item.sort}</div>
                          <div className='stm-width-20-percent stm-padding-8'>
                            <>
                              {
                                !item.isPrimary && !selectedData
                                  ?
                                  <>
                                    <Button
                                      type={item.isAvailable ? 'primary' : 'default'}
                                      className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                      onClick={() => this.props.CmsLanguageStore.edit(item.id)}>Edit</Button>
                                    {
                                      item.isAvailable
                                        ?
                                        <>
                                          <Button
                                            type='default'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                            onClick={() => this.deactivate(item.id)}>Disabled</Button>
                                        </>
                                        :
                                        <Button
                                          type='default'
                                          className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                          onClick={() => this.activate(item.id)}>Enabled</Button>
                                    }
                                  </>
                                  :
                                  null
                              }
                            </>
                          </div>
                        </div>
                        <>
                          {
                            selectedData && item.id === selectedData.id
                              ?
                              <>
                                <div className='stm-font-size-14 
                                                stm-line-height-18
                                                stm-color-495057 
                                                stm-text-align-center 
                                                stm-border-style-solid 
                                                stm-border-width-1 
                                                stm-border-color-white-two 
                                                stm-border-radius-4 
                                                stm-padding-16'>
                                  <div className='stm-font-size-18 stm-line-height-20 stm-font-weight-bold stm-margin-bottom-16'>Update Language</div>
                                  <div className='stm-display-flex stm-stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-50-percent stm-text-align-right stm-padding-right-16'>Name</div>
                                    <div className='stm-font-weight-bold stm-padding-left-16'>{selectedData.name}</div>
                                  </div>
                                  <div className='stm-display-flex stm-stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-50-percent stm-text-align-right stm-padding-right-16'>Original Name</div>
                                    <div className='stm-font-weight-bold stm-padding-left-16'>{selectedData.originalName}</div>
                                  </div>
                                  <div className='stm-display-flex stm-stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-50-percent stm-text-align-right stm-padding-right-16'>Sort</div>
                                    <div className='stm-padding-left-16'>
                                      <InputNumber
                                        min={1}
                                        value={selectedData.sort}
                                        onChange={(value) => this.props.CmsLanguageStore.setSort(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-stm-width-100-percent stm-margin-bottom-16'>
                                    <div className='stm-width-50-percent stm-text-align-right stm-padding-right-16'>Is Available</div>
                                    <div className='stm-padding-left-16'>
                                      <Switch
                                        checkedChildren='Yes'
                                        unCheckedChildren='No'
                                        checked={selectedData.isAvailable}
                                        onChange={(value) => this.props.CmsLanguageStore.setIsAvailable(value)} />
                                    </div>
                                  </div>
                                  <div className='stm-margin-top-36'>
                                    <Button
                                      type='primary'
                                      className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-8'
                                      onClick={this.update}>Update</Button>
                                    <Button
                                      type='default'
                                      className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                      onClick={() => this.props.CmsLanguageStore.cancelUpdate()}>Cancel</Button>
                                  </div>
                                </div>
                              </>
                              :
                              null
                          }
                        </>
                      </>
                    )
                  })
                }
              </>
            </Form.Item>
          </Grid>
        </Grid>
      </MainContainer>
    )
  }
}

export default CmsLanguage;